import { DocumentData, DocumentReference } from "@angular/fire/firestore";

export class CitySummary {
  public readonly name: string;
  public readonly reference: DocumentReference;
  public readonly state: string;

  constructor(data: DocumentData) {
    this.name = data.name;
    this.reference = data.reference as DocumentReference;
    this.state = data.state;
  }
}
